import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusChip from '../design/StatusChip';
import { statusFromScore } from '../utils/pasuk';

interface AttemptResultCardProps {
  score: number;
  explanation: string;
  saved: boolean;
}

const AttemptResultCard: React.FC<AttemptResultCardProps> = ({ score, explanation, saved }) => {
  const { t } = useTranslation();
  return (
    <div
      className="mt-4 rounded-2xl border border-school-line bg-school-surface p-5"
      aria-live="polite"
    >
      <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-extrabold tabular-nums text-school-ink">{score}</span>
          <span className="text-sm text-school-muted">{t('school_score_out_of')}</span>
        </div>
        {saved && <StatusChip status={statusFromScore(score, 1)} />}
      </div>
      {explanation && (
        <p className="whitespace-pre-line text-sm leading-relaxed text-school-ink">{explanation}</p>
      )}
    </div>
  );
};

export default AttemptResultCard;
